import { FC } from "react";

import { OAuthRedirectDesktopPageBase } from "@/pages/oauth-redirect-desktop/oauth-redirect-desktop-page-base";

export const AppleOAuthRedirectDesktopPage: FC = () => {
  return (
    <OAuthRedirectDesktopPageBase
      deepLinkPath="apple-oauth-redirect"
      logPrefix="AppleOAuthRedirectDesktopPage"
    />
  );
};
